import React from 'react'
import { Translate } from 'utils/localize'
import { RewardListModel } from 'models/recruit/RewardListModel'
import { Section } from 'layouts'
import { Heading } from 'layouts/headings'
import { Friends, Achievements } from './components'
import style from './Rewards.module.scss'

interface Props {
    hasContent: boolean
    rewards: RewardListModel
}

const Rewards = ({ hasContent, rewards }: Props): JSX.Element => {
    return (
        <Section hasContent={hasContent}>
            <div className={style.rewards}>
                <Heading isRecruit small>
                    <Translate id="recruit.yourRecruits">
                        Your Recruits
                    </Translate>
                </Heading>
                <p>
                    <Translate id="recruit.asYourRecruitsAchieve">
                        As your recruits achieve milestones, you will receive
                        rewards. Here are the rewards you have received so far
                        from their achievements.
                    </Translate>
                </p>
                {rewards.friends && <Friends friends={rewards.friends} />}
                <p>
                    <Translate id="recruit.asMoreOfYourRecruits">
                        As more of your recruits upgrade to Omega, you will
                        receive further, better rewards. You can track their
                        progress here:
                    </Translate>
                </p>
                {rewards.accountRewards && (
                    <Achievements
                        omegaClonePurchased={
                            rewards.accountRewards.OmegaClonePurchased
                        }
                    />
                )}
            </div>
        </Section>
    )
}

export default Rewards
